import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import React, { createContext, useContext, useEffect, useState, useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var AlertTypeEnum = /*#__PURE__*/function (AlertTypeEnum) {
  AlertTypeEnum["success"] = "success";
  AlertTypeEnum["warning"] = "warning";
  AlertTypeEnum["error"] = "error";
  AlertTypeEnum["primary"] = "primary";
  return AlertTypeEnum;
}({});
var AlertContext = /*#__PURE__*/createContext({
  alert: null,
  showAlert: function showAlert() {},
  hideAlert: function hideAlert() {},
  registerAlertComponent: function registerAlertComponent() {},
  unregisterAlertComponent: function unregisterAlertComponent() {},
  getCurrentAlert: function getCurrentAlert() {
    return null;
  }
});
export var useAlert = function useAlert() {
  return useContext(AlertContext);
};
export var AlertProvider = function AlertProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    alert = _useState2[0],
    setAlert = _useState2[1];
  var alertComponentStack = useRef([]);
  useEffect(function () {
    if (alert) {
      var timer = _setTimeout(function () {
        setAlert(null);
      }, alert.duration || 2000);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [alert]);
  var registerAlertComponent = function registerAlertComponent(id) {
    alertComponentStack.current.push(id);
  };
  var unregisterAlertComponent = function unregisterAlertComponent(id) {
    var _context;
    var index = _indexOfInstanceProperty(_context = alertComponentStack.current).call(_context, id);
    if (index > -1) {
      var _context2;
      _spliceInstanceProperty(_context2 = alertComponentStack.current).call(_context2, index, 1);
    }
  };
  var showAlert = function showAlert(_ref2) {
    var message = _ref2.message,
      type = _ref2.type,
      _ref2$duration = _ref2.duration,
      duration = _ref2$duration === void 0 ? 2000 : _ref2$duration,
      leadingIcon = _ref2.leadingIcon;
    // Keep the original showAlert signature but add scoping logic
    if (alertComponentStack.current.length > 0) {
      var targetComponentId = alertComponentStack.current[alertComponentStack.current.length - 1];
      setAlert({
        message: message,
        type: type,
        duration: duration,
        leadingIcon: leadingIcon,
        scopeId: targetComponentId
      });
    } else {
      // Fallback to root scope
      setAlert({
        message: message,
        type: type,
        duration: duration,
        leadingIcon: leadingIcon,
        scopeId: "root"
      });
    }
  };
  var hideAlert = function hideAlert() {
    setAlert(null);
  };
  var getCurrentAlert = function getCurrentAlert(componentId) {
    // Only return the alert if this component should show it
    if (alert && alert.scopeId === componentId) {
      return alert;
    }
    return null;
  };
  return /*#__PURE__*/_jsx(AlertContext.Provider, {
    value: {
      alert: alert,
      showAlert: showAlert,
      hideAlert: hideAlert,
      registerAlertComponent: registerAlertComponent,
      unregisterAlertComponent: unregisterAlertComponent,
      getCurrentAlert: getCurrentAlert
    },
    children: children
  });
};